import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Table, Modal } from "react-bootstrap";
import { toast } from "react-hot-toast";
import HeaderCard from "../../components/common/HeaderCard";
import BackButton from "../../components/common/BackButton";
import css from "../../css/admin/home-page.module.css";
import { SERVER_ORIGIN } from "../../utilities/constants";

const YuvaEcRolesPage = () => {
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [form, setForm] = useState({ name: "", sector: "", isActive: true });

  const fetchRoles = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${SERVER_ORIGIN}/api/admin/auth/yuva-ec-roles/all`, {
        headers: { "auth-token": sessionStorage.getItem("token") },
      });
      const result = await response.json();
      if (response.ok) setRoles(result.data || []);
      else toast.error(result.message || "Failed to fetch roles");
    } catch (e) {
      console.error(e);
      toast.error("Failed to fetch roles");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const openAdd = () => {
    setEditingRole(null);
    setForm({ name: "", sector: "", isActive: true });
    setShowModal(true);
  };

  const openEdit = (role) => {
    setEditingRole(role);
    setForm({ name: role.name || "", sector: role.sector || "", isActive: !!role.isActive });
    setShowModal(true);
  };

  const saveRole = async () => {
    if (!form.name.trim()) {
      toast.error("Role name is required");
      return;
    }

    try {
      const url = editingRole
        ? `${SERVER_ORIGIN}/api/admin/auth/yuva-ec-roles/${editingRole._id}`
        : `${SERVER_ORIGIN}/api/admin/auth/yuva-ec-roles/add`;

      const method = editingRole ? "PUT" : "POST";
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        },
        body: JSON.stringify(form),
      });
      const result = await response.json();
      if (response.ok) {
        toast.success("Saved");
        setShowModal(false);
        fetchRoles();
      } else {
        toast.error(result.message || "Failed to save");
      }
    } catch (e) {
      console.error(e);
      toast.error("Failed to save");
    }
  };

  const deleteRole = async (role) => {
    if (!window.confirm(`Delete role "${role.name}"?`)) return;
    try {
      const response = await fetch(`${SERVER_ORIGIN}/api/admin/auth/yuva-ec-roles/${role._id}`, {
        method: "DELETE",
        headers: { "auth-token": sessionStorage.getItem("token") },
      });
      const result = await response.json();
      if (response.ok) {
        toast.success("Deleted");
        fetchRoles();
      } else {
        toast.error(result.message || "Failed to delete");
      }
    } catch (e) {
      console.error(e);
      toast.error("Failed to delete");
    }
  };

  return (
    <div className={css.outerDiv}>
      <HeaderCard>
        <BackButton text="Back to Dashboard" customPath="/admin/services" />
        <h1 className="headerTitle">YUVA EC Roles Master</h1>
        <hr />
      </HeaderCard>

      <div className="container-fluid mt-4">
        <Row className="mb-3">
          <Col>
            <Button onClick={openAdd}>Add Role</Button>
          </Col>
        </Row>

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Role Name</th>
              <th>Sector</th>
              <th>Active</th>
              <th style={{ width: 180 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {(roles || []).map((r) => (
              <tr key={r._id}>
                <td>{r.name}</td>
                <td>{r.sector || "-"}</td>
                <td>{r.isActive ? "Yes" : "No"}</td>
                <td>
                  <Button size="sm" variant="outline-primary" className="me-2" onClick={() => openEdit(r)}>
                    Edit
                  </Button>
                  <Button size="sm" variant="outline-danger" onClick={() => deleteRole(r)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
            {(!roles || roles.length === 0) && (
              <tr>
                <td colSpan={4}>{isLoading ? "Loading..." : "No roles found"}</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editingRole ? "Edit Role" : "Add Role"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Role Name *</Form.Label>
              <Form.Control
                value={form.name}
                onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Sector</Form.Label>
              <Form.Control
                value={form.sector}
                onChange={(e) => setForm((p) => ({ ...p, sector: e.target.value }))}
              />
            </Form.Group>
            <Form.Check
              type="switch"
              id="role-active"
              label="Active"
              checked={!!form.isActive}
              onChange={(e) => setForm((p) => ({ ...p, isActive: e.target.checked }))}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={saveRole}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default YuvaEcRolesPage;

